import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { AppContext } from "../../Context";
import Fetch, { Loader, Get, priceFormat } from "../inc/Fetch";
import Product from "../components/product/Product";
import ErrorPage from "./ErrorPage";

import { MdArrowForwardIos } from "react-icons/md";
import { FaSearch } from "react-icons/fa";

import Header from "./Header";
import Footer from "./Footer";

// ads

import './css/Cats.css'

export default function Search() {

    const { t } = useTranslation();
    let ref = useRef();
    const params = useParams();

	const {siteData} = useContext(AppContext); 
	const [siteInfo, setsiteInfo] = siteData;

    const [loader, setloader] = useState(false);
    const [data, setdata] = useState([]);
    const [search, setsearch] = useState("");
    const [sort, setsort] = useState('date');
    



    async function loadData() {
        
        let res = await Fetch('cats', { sort:sort, search: search, page:"search" });
        setdata(res);
        setloader(false);
        return res;
    }

    async function submit(e) {
        e.preventDefault();

        setloader(true);

        loadData();
    }

    useEffect(() => {
        if (sort) {
            loadData();
        }
    }, [sort]);


    // if (loader) {
    //     return <Loader />;
    // }

    if (data?.error) {
        return <ErrorPage />
    }

    

	return (
		<>
            {loader && <Loader />}
            <Helmet>
                <title>{t("search")}</title>
                <meta property="og:title" content={data?.cat?.name} />
            </Helmet>

			<Header title={true} /> 

            <div className={`effect inside search`}>

                <div className='blend'></div>
                <form onSubmit={submit} className='mainWidth searchBox'>
                    <input type='search' onChange={d => setsearch(d?.target?.value)} autoFocus placeholder={`${t("search")}...`} />
                    <button ><FaSearch /></button>
                </form>
                
            </div>

            <nav className='mainWidth pathNames search'> 
                <Link to='/'>{t("home")}</Link>
                <MdArrowForwardIos />
                <Link to='/cat'>{t("all_products")}</Link>
                <MdArrowForwardIos />
                <Link>{t("search")}</Link>
                <MdArrowForwardIos />
                <Link>{search}</Link>
            </nav>

        

            <div className='mainWidth ' style={{marginBottom:40,}}>

                <div className='homeTopProducts' style={{padding:0}}>

                    <div className='filterBox'>
                        <span>
                            {data?.search && 
                            <>
                                {t("products_res")} <b>{data?.info?.count}</b> 
                            </>}
                        </span>

                        <select onChange={(e) => setsort(e.target.value)} name='sort'>
                            <option value='date'>{t("sort_by_1")}</option>
                            <option value='sold'>{t("sort_by_2")}</option>
                            <option value='price'>{t("sort_by_3")}</option>
                            <option value='price2'>{t("sort_by_4")}</option>
                        </select>
                    </div>


                    <div className='productsBox list5' style={{marginTop:0, padding:20}}>
                        {data?.products?.length ? data?.products?.map((v, k) => {
                            return (
                                <Product data={v} key={k} /> 
                            );
                        }): <div className='noData'>{data?.search ? t("search_no_data") : t("search_first")}</div>}

                    </div>
        
                </div>

                
       

            </div>
            
            <Footer />
		</>
	)
}
